import ReactDOM from 'react-dom';
import Root from '../tools/hns/index';

import '../../sass/apps/hns/hns.scss';

if (document.getElementById('hns-app')) {
  ReactDOM.render(<Root />, document.getElementById('hns-app'));
}
